__turbopack_context__.v({
  "columnWrapper": "styles-module__VUFeYq__columnWrapper" + " " + "styles-module__VUFeYq__wrapper",
  "errorText": "styles-module__VUFeYq__errorText",
  "loader": "styles-module__VUFeYq__loader",
  "rowWrapper": "styles-module__VUFeYq__rowWrapper" + " " + "styles-module__VUFeYq__wrapper",
  "wrapper": "styles-module__VUFeYq__wrapper",
});
